import React from 'react';
import { Header } from '../../row/header';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setPageType } from '../../actions/builder-action';
import AheadPreview from '../../ahead/ahead-preview';

function Metering() {
  const { publisherId = '' } = useParams();
  const dispatch = useDispatch();
  dispatch(setPageType('meteredPaywall'));
  return (
    <>
      <Header publisherId={publisherId} />
      <AheadPreview hideHeader hideBreakingNews hideFooter />
    </>
  );
}

export default Metering;
